<template>
    <v-container  v-resize="onResize">
        <v-layout row wrap align-center v-if="parliament">
            <v-flex xs12 md6>
                <v-btn :to="{ name: 'DivisionsForParliament' }" color="white">
                    <v-icon dark left>arrow_back</v-icon>Back to divisions for {{ parliament }}
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap pt-3 pb-4 align-center>
            <v-flex xs12 md6>
                <h1>{{ division.Title | divisionTitle }}</h1>
                <h3 class="blue-grey--text text--darken-1">{{ division.Date | stringDateFormat }}</h3>

                <br/>
                
                <div class="division-detail-row" v-if="division.DivisionNumber">
                    <div class="division-detail-heading">Division Number</div>
                    <div>{{ division.DivisionNumber }}</div>
                </div>
                            
                <div class="division-detail-row" v-if="division.Context">
                    <div class="division-detail-heading">Context</div>
                    <div>{{ division.Context }}</div>
                </div>

                <div class="division-detail-row" v-if="division.Mover">                           
                    <div class="division-detail-heading">Mover</div>
                    <div>{{ division.Mover.Name }}</div>
                </div>

                <div class="division-detail-row" v-if="division.Question">       
                    <div class="division-detail-heading">Question</div>
                    <div>{{ division.Question }}</div>
                </div>
                
                <br/>
                <v-chip v-if="division.Outcome === 0" small label color="green">Agreed to</v-chip>
                <v-chip v-if="division.Outcome === 1" small label color="red">Negatived</v-chip>
            </v-flex>
        </v-layout>

        <loader v-if="loading" />
        <template v-if="!loading" >

            <v-layout row wrap>
                <v-flex xs12>

                    <v-btn color="primary" :href="division.AphLink" target="_blank" v-if="division.AphLink">
                        APH
                    </v-btn>

                    <v-btn color="primary" :href="division.HansardLink" target="_blank" v-if="division.HansardLink">
                        Hansard
                    </v-btn>

                    <v-btn color="primary" :href="division.ChamberDocument" target="_blank" v-if="division.ChamberDocument">
                        {{ chamberDocument }}
                    </v-btn>

                    <v-btn v-for="bill in division.Bills" :key="bill" color="info" :href="bill" target="_blank">
                        Bill
                    </v-btn>

                </v-flex>
            </v-layout>         

            <br/>

            <chart :chartData="chartData"/>

            <br/>
            <br/>

            <v-layout row wrap align-center justify-space-between>
                <v-btn-toggle v-model="voteType" class="transparent handbook_toggleButton" :mandatory="true">
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="0">
                                <span class="long-button-text chamberButton">Ayes ({{ ayeCount }})</span>
                            </v-btn>
                        </template>
                        <span>Ayes ({{ ayeCount }})</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="1">
                                <span class="long-button-text chamberButton">Noes ({{ noCount }})</span>
                            </v-btn>
                        </template>
                        <span>Noes ({{ noCount }})</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="2">
                                <span class="long-button-text chamberButton">Pair ({{ pairCount }})</span>
                            </v-btn>
                        </template>
                        <span>Pair ({{ pairCount }})</span>
                    </v-tooltip>
                </v-btn-toggle>
            </v-layout>

            <br/>
            
            <!-- grouped by party -->
            <v-container grid-list-md v-if="!loading">
                <v-layout v-for="(votes, propertyName) in groupedVotes" :key="propertyName">
                    <v-flex xs12 >
                        <h2>{{ votes[0].PartyName }} ({{ votes.length }})</h2>
                        <br/>
                        <v-data-iterator :items="votes"
                                        :hide-actions="true"
                                        content-tag="v-layout" row wrap>

                            <template v-slot:item="props" loading-text="Data loading, please wait" no-results="No criterion matches found">
                                <v-flex xs6 md4 lg2>
                                    <router-link :to="{ name: 'ParliamentarianDivisions', params: { PHID: props.item.Phid }}">
                                        <v-card color="grey lighten-5">
                                            <v-flex>
                                                <v-layout>
                                                    <v-flex xs3>
                                                        <Portrait v-bind:PHID="props.item.Phid" :fixedHeight="100"></Portrait>
                                                    </v-flex>
                                                    <v-flex xs9 class="d-flex">
                                                        <v-card-title primary-title class="justify-center">
                                                            <h3 class="text-xs-center">{{ props.item.ParliamentarianName }}</h3>
                                                        </v-card-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-card>
                                    </router-link>
                                </v-flex>
                            </template>

                            <template v-slot:no-data>
                                <v-alert :value="true" color="info" outline icon="info">No results found</v-alert>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="info" outline icon="info">
                                    Your search for "{{ SELECTED_SEARCH }}" found no results.
                                </v-alert>
                            </template>
                        </v-data-iterator>
                    </v-flex>
                </v-layout>
            </v-container>

            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>         
        </template>
    </v-container>
</template>
<script>
import Portrait from '@/components/Portrait.vue'
import Loader from '@/components/Loader.vue';
import Chart from './Chart.vue';
import axios from 'axios';
import moment from 'moment'
import groupBy from 'lodash.groupby';
import _ from 'lodash';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['parliament', 'chamber', 'id'],
    created() {
        this.initialiseItems();
        this.initialiseMinistries();
    },
    components: {
        Loader,
        Portrait,
        Chart,
    },
    mounted() {
        this.onResize();
    },
    methods: {
        getPartyName(id) {
            return this.parties.find(p => p.partyId == id) ?
            this.parties.find(p => p.partyId == id).partyName : 'Independent';
        },
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        initialiseItems() {
            this.loading = true;
            const url = `StatisticalInformation/Division?id=${this.id}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.division = response.data;
                    this.loading = false;
                });
        },
        initialiseMinistries() {
            this.loadingMinistries = true;
            const url = `StatisticalInformation/Ministries`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.ministries = response.data;
                    this.loadingMinistries = false;
                });
        },
        exportCsv: function () {
            this.csvDownloading = true;

            const chamberDocument = this.division.ChamberDocument;

            const bill = this.division.Bill;

            const hansard = this.division.HansardLink

            const records = this.division.Votes
                .map(i => 
                ({ 
                    Phid: i.Phid,
                    Parliamentarian: i.ParliamentarianName,
                    Party: i.PartyName,
                    Vote: i.VoteType === 0 ? 'Aye' : 
                    (i.VoteType === 2 ? 'Pair' : 'No')
                }));
            let headers = ['Phid, Parliamentarian, Party, Vote'];
            const filename = `${this.division.Title} - ${new Date(this.division.Date).toLocaleDateString()}`;
            let comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            if (hansard) {
                comment += `\n Hansard: ${hansard}`;
            }
            if (chamberDocument) {
                comment += `\n ${this.chamberDocument}: ${chamberDocument}`;
            }
            if (bill) {
                comment += `\n Bill homepage: ${bill}`;
            }
            comment += '\n';

            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        },
        stringDate (value) {
            if (value && value != 'undefined' && value != 'Undefined' 
            && value != '1900-01-01' 
            && value != '1900-01-01T00:00:00Z' 
            && value != '1900-01-1' 
            && value != '0001-01-01'
            && value != '0001-01-01T00:00:00Z') {
                var dateDMY = moment(String(value));
                if (dateDMY.isValid()){
                    return dateDMY.format('DD/MM/YYYY');
                }
                else {
                    var dateFormat =  moment(String(value), 'YYYY-DD-MM');
                    if (dateFormat.isValid()){
                        return dateFormat.format('DD/MM/YYYY');
                    }
                    else {
                        return ''
                    }
                }
            } else {
                return 'present'
            }
        }
    }, 
    filters: {
        divisionTitle: function (value) {
            if (value) {
                let splitTitle = value.split(';')
                .slice(0, -1);
                return splitTitle.join(' - ');
            }
            return '';
        }
    },
    computed: {
            csvDownloadIcon() {
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            detailedCsvDownloadIcon() {
                return this.detailedCsvDownloading ? 'cached' : 'text_snippet';
            },
            detailedCsvDownloadClass() {
                let csvClass = 'mr-1';
                if (this.detailedCsvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            filteredVotes() {
                return this.division ?
                this.division.Votes.filter(v => v.VoteType === this.voteType)
                :
                []
            },
            ayeCount() {
                return this.division.Votes.filter(v => v.VoteType === 0).length;
            },
            noCount() {
                return this.division.Votes.filter(v => v.VoteType === 1).length;
            },
            pairCount() {
                return this.division.Votes.filter(v => v.VoteType === 2).length;
            },
            chamberDocument() {
                return this.division.ChamberType === 0 ? 'Votes and Proceedings' : 'Journals of the Senate'
            },
            parties() {
                return this._.uniqBy(this.division
                .Votes
                .map(v => ({
                    partyId: v.PartyId,
                    partyName: v.PartyName
                })), 'partyId' )
            },
            groupedVotes() {
                // group votes
                return _.orderBy(groupBy(this.filteredVotes, v => v.PartyId), [d => d.length], ['desc']);
            },
            chartData() {
                const series = 
                        _.map(groupBy(this.division.Votes, v => v.PartyName), (v, i) => ({
                            name: i,
                            color: v[0].PartyColour,
                            data: [v.filter(t => t.VoteType === 0).length, v.filter(t => t.VoteType === 1).length]
                        })) ;

            return {

                chart: {
                    type: 'column',
                    height: 300
                },
                title: {
                    text: 'Division results',
                },
                xAxis: {
                    categories: ['Ayes', 'Noes']
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Votes'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            textOutline: 'none'
                        }
                    }
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                    }
                },
                series
            };
        }
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
            isMobile: false,
            ROWS_LISTITEMS: [{
                "text": "$vuetify.dataIterator.rowsPerPageAll",
                "value": -1
            }],
            title: 'Divisions',
            chartType: 'perYear',
            headers: [
                { text: 'Date', value: 'Date' },
                { text: 'Title', value: 'Title' },
                { text: 'Ayes', value: 'Ayes' },
                { text: 'Noes', value: 'Noes' },
                { text: 'Outcome', value: 'Outcome' },
            ],
            division: {},
            selectedMpOrSenator: 'mp',
            ministries: [],
            search: '',
            voteType: 0,
            loading: true,
            loadingMinistries: true,
            csvDownloading: false,
            detailedCsvDownloading: false
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }

    .division-detail-row {
        display: flex;
    }

    .division-detail-heading {        
        width: 120px;
        font-weight: 700;
    }
</style>
